const loginDictIT = {
  to: "a",
  signInWith: "Accedi con le credenziali del tuo account attivo",
  forgotPassword: "Hai dimenticato la password?",
  sendEmail: "Invia Email",
  // toast
  pleaseFillOut: "Si prega di compilare i campi nome utente e password.",
  pleaseReverify: "Si prega di verificare nuovamente ReCaptcha.",
  incorrectCredentials: "Credenziali errate.",
  tooManyLoginAttempts: "Troppi tentativi di accesso non riusciti. Riprova tra qualche minuto o usa \"Hai dimenticato la password?\".",
  pleaseCheckEmail: "Controlla il tuo indirizzo email per attivare il tuo account.",
  pleaseCheckEmailTemp:
    "Controlla il link inviato alla tua email per cambiare la password. Sarà valida per 60 minuti.",
  userNotFound: "Utente non trovato.",
  thisEmailDoesnt: "Questa email non corrisponde a questo utente.",
  error: "Errore",
  success: "Successo",
  notRegisteredYetRegisterAs: "Non ancora registrato? Registrati come",
  welcomeBack: "Benvenuto",
  emailOrUsername: "E-mail o nome utente",
  enterRegisteredEmail: "Inserisci l’e-mail registrata",
  enterYourPassword: "Inserisci la tua password",
  rememberMe: "Ricordami",
  accessMyAccount: "Accedi al mio account",
  notPartOfNetwork: "Non fai ancora parte della rete?",
  createAccountNow: "Crea subito il tuo profilo e inizia a generare valore.",
  loginAndKeepGrowing: "Accedi e continua a crescere con Extraconomy",
  accessYourAccountDescription:
    "Entra nel tuo account e cogli nuove opportunità per ampliare la tua rete, i tuoi guadagni e il tuo impatto.", // Reset Password
  resetPassword: "Reimposta Password",
  enterNewPassword: "Inserisci la tua nuova password",
  newPassword: "Nuova Password",
  confirmPassword: "Conferma Password",
  confirmNewPassword: "Conferma la tua nuova password",
  changePassword: "Cambia Password",
  backToLogin: "Torna al login",
  invalidLink: "Link non valido o scaduto. Reindirizzamento al login...",
  passwordsDoNotMatch: "Le password non corrispondono.",
  passwordTooShort: "La password deve essere di almeno 8 caratteri.",
  passwordChangedSuccessfully: "Password cambiata con successo! Reindirizzamento al login...",
  errorChangingPassword: "Errore nel cambio password. Riprova o richiedi un nuovo link.",
  resetYourPassword: "Reimposta la tua password",
  createNewPasswordDescription: "Crea una nuova password per riottenere l'accesso al tuo account.",
  passwordAlreadyChanged: "Questa richiesta di modifica della password è già stata utilizzata.",
  enterTheEmailAddressAssociatedYourAccount: "Inserisci l’e-mail associata al tuo account",
  weWillSendYouALinkToSecurelyCreateANewPassword:
    "Ti invieremo un link per creare una nuova password in modo sicuro",
  active: "Attivo",
  memberCount: "Numero di membri",
  subnets: "Sub-reti",
  subnet: "Sub-rete",
  loginSEODescription:
    "Accedi a Extraconomy per accedere al tuo account, ampliare la tua rete di contatti e sfruttare opportunità di business esclusive.",
  // Entrada vinda da Federnet (FedernetHandoff.js)
  federnetHandoffLoading: "Ti stiamo portando su Extraconomy…",
  federnetHandoffErrorTitle: "Accesso non riuscito",
  federnetHandoffErrorText:
    "Il link per entrare da Federnet è scaduto o è già stato usato. Accedi con il tuo nome utente e la tua password.",
  federnetHandoffGoToLogin: "Vai al login",
};

export default loginDictIT;
